<style scoped lang="scss">
  .lists{
    display: flex;
    justify-content: space-around;
    text-align: center;
    p{
      margin-top: 10px;
    }
  }
  .container10{
    margin-top: 80px;
  }
  .container10 h1{
    font-size: 70px;
    color: #014492;
  }
  .cons{
    display: none;
  }
  .container10 h2{
    font-size: 40px;
    color: #014492;
  }
  .container10 .a{
    width: 800px;
    height: 6px;
    margin-top: 30px;
    margin-bottom: 40px;
    background: #ccc;
    position: relative;
  }
  .container10 .a span{
    width: 50px;
    height: 6px;
    position: absolute;
    left: 0;
    top: 0;
    background: #014492;
  }
</style>
<style scoped>
@import url("../../assets/sanger.css");
@import url("../../assets/service.css");
</style>
<template>
  <div class="wrap wrap-tec">
<!--    <div class="banner">-->
<!--      <img src="@/assets/images/banner_17.png" class="img-fluid">-->
<!--      <div class="info">-->
<!--        <div class="container">-->
<!--          <h1>原核转录组测序</h1>-->
<!--          <h2 class="mt10">Prokaryotic transcriptome sequencing</h2>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
    <div class="container container10">
      <h1>原核转录组测序</h1>
      <h2 class="mt10">Prokaryotic Transcriptome Sequencing</h2>
      <div class="a"><span></span></div>
    </div>
    <div class="breads container" style="overflow:auto;line-height: 48px;padding-left: 10px;">
      <bread></bread>
    </div>
    <section class="container">
      <p class="desc">原核转录组测序是基于Illumina测序平台，构建链特异性文库，研究原核生物在某个时期或者某种环境条件下转录出来的所有mRNA。由于原核生物mRNA没有polyA尾结构，需要采用去除rRNA的方法构建文库，擎科生物针对不同的研究物种采取有效的方法去除rRNA，保证数据质量。</p>
      <div class="c-title">应用领域</div>
      <div class="con">
        <ul class="lists">
          <li>
            <img src="@/assets/images/prokaryotic_icon_1.png">
            <p>基因表达量分析</p>
          </li>
          <li>
            <img src="@/assets/images/prokaryotic_icon_2.png">
            <p>差异基因鉴定</p>
          </li>
          <li>
            <img src="@/assets/images/prokaryotic_icon_3.png">
            <p>非编码RNA鉴定</p>
          </li>
        </ul>
      </div>
      <div class="cons" style="margin-top: 20px;">
        <ul class="lists">
          <li>
            <img src="@/assets/images/prokaryotic_icon_1.png">
            <p>基因表达量分析</p>
          </li>
          <li>
            <img src="@/assets/images/prokaryotic_icon_2.png">
            <p>差异基因鉴定</p>
          </li>
          <li>
            <img src="@/assets/images/prokaryotic_icon_3.png">
            <p>非编码RNA鉴定</p>
          </li>
        </ul>
      </div>

      <div class="c-title">技术参数</div>
      <ul class="lists">
        <li>
          <img src="@/assets/images/prokaryotic_icon_4.png">
          <h4>测序平台及策略</h4>
          <p>Hiseq/Novaseq PE150</p>
        </li>
        <li>
          <img src="@/assets/images/prokaryotic_icon_5.png">
          <h4>项目周期</h4>
          <p>30个工作日</p>
        </li>
        <!-- <li>
          <img src="@/assets/images/prokaryotic_icon_6.png">
          <h4>测量数据量</h4>
          <p>2 G</p>
        </li> -->
        <li>
          <img src="@/assets/images/prokaryotic_icon_7.png">
          <h4>数据质量</h4>
          <p>Q30 > 80%</p>
        </li>
      </ul>
      <div class="c-title">技术路线</div>
      <div class="tc con"><img src="@/assets/images/prokaryotic_1.png"> </div>
      <div class="tc cons" style="margin-top: 20px;"><img src="@/assets/images/prokaryotic_1.png"> </div>
    </section>
    <qk-consult type="Virus"/>
  </div>
</template>
<script>
import bread from "@/components/bread"
export default {
  inject: ['reload'],
  components: {
    bread,
  },
  data () {
    return {

    }
  },
  created() {
    this.reload()
  },
  methods: {

  }
}
</script>



// WEBPACK FOOTER //
// src/views/tec/prokaryotic.vue